import { useEffect, useState } from 'react';
import { postMABAA061 } from '../../../services/Api';
import { useParams, useSearchParams } from 'react-router-dom';
import Pagination from '../../../shared/components/Pagination';
import { formatNumberWithCommas } from '../../../utils';

const MABAA061 = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [searchParams] = useSearchParams();
    const [pages, setPages] = useState({});
    const page = Number(searchParams.get('page')) || 1;

    useEffect(() => {
        postMABAA061(id, { page })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    }, [id, page]);

    return (
        <div className="profile-content">
            <div className="title-profile">활동 내역</div>
            <div className="detailed-list-of-activities">
                <div className="title-table">활동내역 목록</div>
                <div className="profile-note">
                    * Action 정의 : <br />
                    회원통합(INTL),로그인(LOGIN),로그아웃(LOGOUT),신규가입(REGIST),회원정보수정(MODIFY),관련정보수정(MODIFY_),관리자요청(ADMIN)
                    <br />* 요청사이트 정의 : DM-&gt;DVMall, DV-&gt;덴탈비타민 Desktop, VA-&gt;(신)덴탈비타민 App,
                    DJ-&gt;덴탈잡, JA-&gt;덴탈잡 App, DA -&gt;덴탈알바, DS-&gt;덴탈세미나
                </div>

                <div className="profile-content-count">
                    총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                </div>
                <table className="table-gray">
                    <thead>
                        <tr>
                            <th style={{ width: '15%' }}>요청사이트</th>
                            <th style={{ width: '31%' }}>Action</th>
                            <th style={{ width: '27%' }}>요청일자</th>
                            <th style={{ width: '27%' }}>요청IP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.length > 0 ? (
                            data.map((item, index) => {
                                return (
                                    <tr key={'payment-history' + index}>
                                        <td>{item?.siteGbn}</td>
                                        <td>
                                            {item?.action?.split(',').map((action, index, array) => (
                                                <span key={index}>
                                                    {action}
                                                    {index < array.length - 1 && ', '}
                                                </span>
                                            ))}
                                        </td>

                                        <td>{item?.actDate}</td>
                                        <td>{item?.regIP}</td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={12}>데이타가 없습니다.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <Pagination pages={pages} />
            </div>
        </div>
    );
};
export default MABAA061;
